import { cn } from '~/utils/cn';

interface PropsPulsingOrb {
  size?: number;
  color?: string;
  className?: string;
}

export default function PulsingOrb({ size = 120, color = '#1D4733', className }: PropsPulsingOrb) {
  return (
    <div
      className={cn('relative flex items-center justify-center', className)}
      style={{ width: size, height: size }}
    >
      <div
        className="absolute inset-0 rounded-full opacity-30 animate-ping"
        style={{ background: color }}
      />
      <div
        className="absolute inset-[15%] rounded-full opacity-60 animate-pulse_soft"
        style={{ background: color }}
      />
      <div
        className="relative rounded-full"
        style={{ width: '60%', height: '60%', background: color }}
      />
    </div>
  );
}
